import {
  DataResult,
  DataStream,
  DataStreamTimeSeriesData,
  WidgetSettingsType,
} from '@thingslog/repositories';
import { DataResultParseStrategy } from './DataResultParseStrategy';
import { DataResultParsed, DataResultParseStream } from '../DataResultParsed';
import {
  applySingleUnitYAxisFormatter,
  createUnitTooltipFormatter,
  getStreamLabel,
  getStreamUnit,
} from '../metadata';
import { formatTooltipValue } from '../../utils/chartDateFormatters';
import { t } from 'i18next';

export class ApiDeviceSensorDataResultParseStrategy implements DataResultParseStrategy {
  public parse(dataResult: DataResult, widgetType: WidgetSettingsType): DataResultParsed {
    const parsed: DataResultParsed = {
      dataStreams: [],
      xAxis: {
        show: true,
        dataKey: 'date',
        formatter: (value: string) => value,
      },
      yAxis: {
        show: true,
        dataKey: 'value',
        formatter: (value: number) => value.toString(),
      },
      legend: {
        show: true,
      },
    };

    const dataStream: DataResultParseStream = {
      data: [],
      visualization: [
        {
          dataKey: 'value',
          fill: '#82ca9d',
          innerRadius: 70,
          outerRadius: 90,
          nameKey: 'date',
        },
      ],
    };

    const units = new Set<string>();

    dataResult.streams.forEach((stream: DataStream) => {
      if (stream.type !== 'timeseries') return;
      const streamLabel = getStreamLabel(stream, t('value', 'Value'));
      const unit = getStreamUnit(stream);
      if (unit) {
        units.add(unit);
      }
      dataStream.visualization[0].name = streamLabel;
      dataStream.visualization[0].unit = unit;

      stream.data.forEach((data: DataStreamTimeSeriesData) => {
        dataStream.data.push({
          date: data.date,
          value: data.value,
        });
      });
    });

    parsed.dataStreams.push(dataStream);

    applySingleUnitYAxisFormatter(parsed, units);
    parsed.tooltip = {
      formatter: createUnitTooltipFormatter(),
      labelFormatter: (value: string | number) => formatTooltipValue(value),
    };

    return parsed;
  }
}
